export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10359.d1cbc65f.jpg";